export default "__VITE_ASSET__c083266f__"